import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
export default {
    name: 'sellContent',
    components: {
        mvtShifter,
        mvtHotleadForm,
    },
    props: {
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        hotleadOpt() {
            return {
                hotleadTitle: `<div class="text-brand">Sell Your Home with <br> ${this.glb.geo && this.glb.geo.city ? this.glb.geo.city : 'Local'}  Real Estate Experts</div>`,
                hotleadType: this.glb.geo && this.glb.geo.city ? 'LocalSellPageSell' : 'ConnectWithSellerAgent',
                buttonText: 'Get Started',
                showAddress: true,
                hideProfile:  true
            };
        },
        sellFastSyle() {
            return this.glb.pageType === 'vsellfast';
        },
        local() {
            return this.glb.geo && this.glb.geo.city ? `${this.glb.geo.city}` : 'Local';
        },
    },
};
